<div class="video-player-container">
    <div style="text-align: center; color: var(--white); background-color: var(--primary); font-weight: bold;
       font-size: 1.1rem;
    " class="w-100 mb-2">
        <i class="fa-solid fa-tv mr-2"></i> Kachiing Player
    </div>
    <video *ngIf="videoUrl" #videoPlayer width="100%" (timeupdate)="onTimeUpdate(videoPlayer)" 
    (loadedmetadata)="onMetadataLoaded(videoPlayer)" style="max-height: 75vh;">
      <source [src]="videoUrl" type="video/mp4" />
      Your browser does not support the video tag.
    </video>
  
    <div class="controls">
      <button (click)="togglePlayPause()" class="my-button-3 mr-5">
        @if(!isPlaying){
            <i class="fa fa-play"></i>

        }@else{
            <i class="fa fa-pause"></i>

        }

      </button>

      <span class="mr-1">{{ durationString }} </span>
  
      <div class="progress-bar" (click)="onProgressBarClick($event, videoPlayer)">
        <div class="progress" [style.width.%]="progress"></div>
      </div>
  
      <span>
        <i class="fa fa-volume-up mr-2 ml-2" aria-hidden="true"></i>
        <input type="range" min="0" max="100" [(ngModel)]="volume" (input)="onVolumeChange()" />
      </span>
      
    </div>
  </div>
  